import useLocale from './useLocale';

interface NumberInputOptions {
  min?: number;
  max?: number;
  decimals?: number;
}

const useNumberInput = () => {
  const { formatNumber, parseNumber, thousandsSeparator, decimalSeparator } = useLocale();

  return ({ min = 0, max = 2 ** 31 - 1, decimals = 2 }: NumberInputOptions) => ({
    filter: (value: string) => (
      value.replace(
        new RegExp(`[^0-9${thousandsSeparator}${decimalSeparator}${min === null || min < 0 ? '-' : ''}]`, 'g'),
        '',
      )
    ),
    parse: (value: string) => {
      if (value === '') {
        return null;
      }

      const parsedValue = parseNumber(value);

      if (!Number.isNaN(parsedValue)) {
        return Math.min(Math.max(parsedValue, min), max);
      }

      return null;
    },
    format: (value: number) => (
      value !== null
        ? formatNumber(value, { useGrouping: false, maximumFractionDigits: decimals }) : ''
    ),
    validate: (value: number) => {
      if (max !== null && value > max) {
        return false;
      }

      if (min !== null && value < min) {
        return false;
      }

      return true;
    },
  });
};

export default useNumberInput;
